(() => {
  const config = document.getElementById('cp-dimension-labels');
  if (!config) return;
  const labels = { x: config.dataset.sideOne, y: config.dataset.sideTwo };
  const root = document.querySelector('main') || document.body;
  const groups = new Set();
  let scheduled = false;

  function install(x) {
    const wrapper = x.closest('.tpo_dimension_wrapper');
    const y = wrapper?.querySelector('input[data-tpo-dimension="y"]');
    if (!y || wrapper.dataset.cpOrientation) return;
    wrapper.dataset.cpOrientation = 'true';
    wrapper.style.flexWrap = 'wrap';
    wrapper.querySelectorAll('label.tpo_dimension_label').forEach(label => {
      if (!label.querySelector('input')) label.style.display = 'none';
    });
    const originals = [x, y];
    const inputs = originals.map((original, index) => {
      const label = document.createElement('label');
      label.className = 'tpo_dimension_label';
      const caption = document.createElement('span');
      caption.className = 'form__label';
      caption.textContent = labels[index ? 'y' : 'x'];
      const holder = document.createElement('div');
      holder.className = 'tpo_dimension_input-wrapper';
      const input = document.createElement('input');
      input.type = 'text';
      input.inputMode = 'decimal';
      input.className = 'tpo_text-box cp-dimension-entry';
      input.style.cssText = 'width:100%;padding:10px;border:1px solid #aaa;border-radius:4px;font:inherit;box-sizing:border-box;';
      input.id = 'cp-side-' + (index + 1) + '-' + x.id;
      input.value = original.value;
      input.required = true;
      holder.append(input);
      label.append(caption, holder);
      wrapper.insertBefore(label, x.closest('label'));
      original.closest('label').style.display = 'none';
      return input;
    });
    const help = document.createElement('p');
    help.id = 'cp-dimension-help-' + x.id;
    help.textContent = config.dataset.orientationHelp;
    help.style.cssText = 'flex:0 0 100%;grid-column:1/-1;margin:8px 0;font-size:1.3rem;';
    const error = document.createElement('p');
    error.id = 'cp-dimension-error-' + x.id;
    error.setAttribute('role', 'status');
    error.style.cssText = 'flex:0 0 100%;grid-column:1/-1;margin:0;color:#b00020;font-size:1.3rem;';
    wrapper.append(help, error);
    inputs.forEach(input => input.setAttribute('aria-describedby', help.id + ' ' + error.id));
    function validate(showError = true) {
      const values = inputs.map(input => Number(input.value.trim()));
      const filled = inputs.every(input => input.value.trim() !== '');
      const valid = filled && values.every(value => Number.isFinite(value) && value >= 18 && value <= 84) && Math.min(...values) <= 40;
      const message = valid ? '' : config.dataset.orientationError;
      inputs.forEach(input => {
        input.setCustomValidity(message);
        input.setAttribute('aria-invalid', filled && !valid ? 'true' : 'false');
      });
      const text = showError && filled ? message : '';
      if (error.textContent !== text) error.textContent = text;
      return valid;
    }
    function sync() {
      const valid = validate();
      const values = valid ? inputs.map(input => Number(input.value.trim())).sort((a, b) => b - a) : ['', ''];
      originals.forEach((input, index) => {
        const value = String(values[index]);
        if (input.value === value) return;
        input.value = value;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    inputs.forEach(input => input.addEventListener('input', sync));
    groups.add({ wrapper, inputs, validate });
    validate(false);
  }

  function update() {
    scheduled = false;
    root.querySelectorAll('input.tpo_dimension_input[data-tpo-dimension]').forEach(input => {
      const caption = input.closest('label.tpo_dimension_label')?.querySelector('.form__label');
      const text = labels[input.dataset.tpoDimension];
      if (text && caption && caption.textContent !== text) caption.textContent = text;
      if (input.id === 'dimension-x-3324167') install(input);
    });
    for (const group of groups) if (!group.wrapper.isConnected) groups.delete(group);
  }

  function blockInvalid(event) {
    const isSubmit = event.type === 'submit';
    const button = event.target.closest?.('button[name="add"], .tpo_add-to-cart, .shopify-payment-button');
    if (!isSubmit && !button) return;
    for (const group of groups) {
      if (!group.wrapper.isConnected || !group.inputs[0].getClientRects().length) continue;
      const formId = group.wrapper.querySelector('input.tpo_dimension_input').getAttribute('form');
      if (isSubmit && event.target.id !== formId) continue;
      if (group.validate()) continue;
      event.preventDefault();
      event.stopImmediatePropagation();
      group.inputs[0].reportValidity();
      group.inputs[0].focus();
      break;
    }
  }
  document.addEventListener('click', blockInvalid, true);
  document.addEventListener('submit', blockInvalid, true);
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  });
  observer.observe(root, { childList: true, subtree: true, characterData: true });
  update();
})();
